module.exports = __webpack_public_path__ + "static/media/GuardiansOfAether-Gallery-16.51bd63b3.jpg";